<template>
  <div class="home flex_1 flex column">
    <!--<Head
      :image-lists="imageLists"
      v-show="$route.name != 'Welcome' && $route.path != '/Login'"
    ></Head> -->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
export default {
  name: "home",
  data() {
    return {
      imageLists: {
        nash_logo: require("../../../assets/Nash-white.png"),
        llot_logo: require("../../../assets/llot-logo.svg"),
        back_home: require("../../../assets/icon-font/Homepage-icon.svg"),
        logout: require("../../../assets/icon-font/logout-icon.svg"),
      },
    };
  },
  methods: {
    ...mapMutations(["setLanguage", "setFamily"]),
  },
  mounted() {
    console.log(window.location);

    if (window.location.hash.includes("=ch")) {
      this.$i18n.locale = "ch";
      this.setLanguage("ch");
      document.querySelector(".lang_cn").classList.add("current");
      document.querySelector(".lang_en").classList.remove("current");
      window.localStorage.setItem("fontFace", "RobotoCondensed-Regular");
    } else {
      this.$i18n.locale = "en";
      this.setLanguage("en");
      document.querySelector(".lang_cn").classList.remove("current");
      document.querySelector(".lang_en").classList.add("current");
      window.localStorage.setItem("fontFace", "RobotoCondensed-Regular");
    }
    // 设置i18n.locale 组件库会按照上面的配置使用对应的文案文件
    // 提交mutations
    this.setFamily(localStorage.getItem("fontFace"));
  },
};
</script>

<style scoped lang="scss">
@import url("../../../assets/scss/common.scss");
.home {
  position: relative;
  width: 100%;
  height: 100%;
}
</style>
